exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".link-1 {\n    fill: #55b900;\n  }\n", ""]);
